module.exports = __webpack_public_path__ + "img/home-hero-image.6564c565.png";